/* maaho-cart-metres.js - keeps each basket line's cloth figure true to its quantity.

   The product page writes properties[_metres] as `fabric:metres:quantity`, asked of the
   back office for the quantity on the page (assets/maaho-product.js). A quantity that
   changes afterwards - Update on the cart page, or the same configuration added twice and
   merged by Shopify into one line - leaves a figure for another quantity, and the checkout
   then withholds express for that line (shipping-vat/src/express.ts). This asks again for
   those lines and writes the new figure back, so the checkout judges the real quantity.

   Reads   the back office address from [data-back-office-url] (sections/maaho-header.liquid,
           from shop.metafields.maaho.back_office_url; blank switches this off), and each
           line's _product, _options and _measurements, as the product page wrote them.
   Offers  window.maahoCartMetres.bringUpToDate(cart) -> Promise<boolean>, true when a line
           was rewritten, so the caller reads the cart again: a rewritten line has a new key.
           Called by assets/maaho-header.js and assets/maaho-cart.js.

   A failed question leaves the line as it was, which only withholds express. */

(function () {
  'use strict';

  var holder = document.querySelector('[data-back-office-url]');
  var backOffice = holder ? (holder.getAttribute('data-back-office-url') || '').replace(/\/+$/, '') : '';

  function numbersIn(written) {
    return String(written || '')
      .split(';')
      .map(function (pair) { return parseFloat((pair.split(':')[1] || '').replace(',', '.')); })
      .filter(function (one) { return isFinite(one); });
  }

  function idsIn(written) {
    return String(written || '')
      .split(',')
      .map(function (one) { return parseInt(one, 10); })
      .filter(function (one) { return isFinite(one); });
  }

  /* A figure worked out for another quantity, or written before the quantity was part of
     it. An empty figure is left alone: it means the line has no cloth to check. */
  function isForAnotherQuantity(item) {
    var written = (item.properties || {})._metres;
    if (!written) return false;
    var parts = String(written).split(':');
    return parts.length < 3 || parts[2] !== String(item.quantity);
  }

  function questionFor(item) {
    var properties = item.properties || {};
    return {
      product_id: parseInt(properties._product, 10) || item.product_id,
      quantity: item.quantity,
      options: idsIn(properties._options),
      measurements: numbersIn(properties._measurements)
    };
  }

  /* One line at a time: two changes in flight can each undo the other. Every property is
     sent back unchanged apart from _metres, since /cart/change.js replaces them all.
     Resolves true only when Shopify accepted a change, so a refused one cannot make the
     cart page reload for ever. */
  function rewrite(items, figures) {
    return items.reduce(function (previous, item, at) {
      return previous.then(function (anyAccepted) {
        var properties = Object.assign({}, item.properties, { _metres: figures[at] });
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties })
        })
          .then(function (response) { return anyAccepted || response.ok; })
          .catch(function () { return anyAccepted; });
      });
    }, Promise.resolve(false));
  }

  function bringUpToDate(cart) {
    var stale = ((cart && cart.items) || []).filter(isForAnotherQuantity);
    if (!backOffice || !stale.length) return Promise.resolve(false);

    return fetch(backOffice + '/storefront/metres', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lines: stale.map(questionFor) })
    })
      .then(function (answer) { return answer.ok ? answer.json() : null; })
      .then(function (said) {
        if (!said || !Array.isArray(said.lines) || said.lines.length !== stale.length) return false;
        var figures = said.lines.map(function (cloth, at) {
          return cloth && cloth.fabric && cloth.metres
            ? cloth.fabric + ':' + cloth.metres + ':' + stale[at].quantity
            : '';
        });
        return rewrite(stale, figures);
      })
      .catch(function () { return false; });
  }

  window.maahoCartMetres = { bringUpToDate: bringUpToDate };
}());
